import { render } from "./StaticPage.vue?vue&type=template&id=631e429b&scoped=true"
import script from "./StaticPage.vue?vue&type=script&lang=js"
export * from "./StaticPage.vue?vue&type=script&lang=js"

import "./StaticPage.vue?vue&type=style&index=0&id=631e429b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-631e429b"],['__file',"resources/js/components/components/StaticPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "631e429b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('631e429b', __exports__)) {
    api.reload('631e429b', __exports__)
  }
  
  module.hot.accept("./StaticPage.vue?vue&type=template&id=631e429b&scoped=true", () => {
    api.rerender('631e429b', render)
  })

}


export default __exports__